import { render, staticRenderFns } from "./context-menu.vue?vue&type=template&id=71dfcdde"
import script from "./context-menu.vue?vue&type=script&lang=js"
export * from "./context-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports